/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkturough_Focus_Plant_FooterInputs */

const en_walkturough_focus_plant_footer = /** @type {(inputs: Walkturough_Focus_Plant_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swipe down to plant`)
};

const ar_walkturough_focus_plant_footer = /** @type {(inputs: Walkturough_Focus_Plant_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرر للأسفل للزراعة`)
};

const de_walkturough_focus_plant_footer = /** @type {(inputs: Walkturough_Focus_Plant_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Pflanzen nach unten wischen`)
};

const es_walkturough_focus_plant_footer = /** @type {(inputs: Walkturough_Focus_Plant_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desliza hacia abajo para plantar`)
};

const fr_walkturough_focus_plant_footer = /** @type {(inputs: Walkturough_Focus_Plant_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glissez vers le bas pour planter`)
};

const it_walkturough_focus_plant_footer = /** @type {(inputs: Walkturough_Focus_Plant_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scorri verso il basso per piantare`)
};

const ja_walkturough_focus_plant_footer = /** @type {(inputs: Walkturough_Focus_Plant_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下にスワイプして植える`)
};

const ko_walkturough_focus_plant_footer = /** @type {(inputs: Walkturough_Focus_Plant_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아래로 스와이프하여 심기`)
};

const pt_br_walkturough_focus_plant_footer = /** @type {(inputs: Walkturough_Focus_Plant_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslize para baixo para plantar`)
};

const ru_walkturough_focus_plant_footer = /** @type {(inputs: Walkturough_Focus_Plant_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проведите вниз, чтобы посадить`)
};

const th_walkturough_focus_plant_footer = /** @type {(inputs: Walkturough_Focus_Plant_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปัดลงเพื่อปลูกต้นกล้า`)
};

const tr_walkturough_focus_plant_footer = /** @type {(inputs: Walkturough_Focus_Plant_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ağaç dikmek için aşağı kaydır`)
};

const zh_cn_walkturough_focus_plant_footer = /** @type {(inputs: Walkturough_Focus_Plant_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向下滑动树苗`)
};

const zh_tw_walkturough_focus_plant_footer = /** @type {(inputs: Walkturough_Focus_Plant_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向下滑動樹苗`)
};

/**
* | output |
* | --- |
* | "Swipe down to plant" |
*
* @param {Walkturough_Focus_Plant_FooterInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const walkturough_focus_plant_footer = /** @type {((inputs?: Walkturough_Focus_Plant_FooterInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkturough_Focus_Plant_FooterInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_walkturough_focus_plant_footer(inputs)
	if (locale === "ar") return ar_walkturough_focus_plant_footer(inputs)
	if (locale === "de") return de_walkturough_focus_plant_footer(inputs)
	if (locale === "es") return es_walkturough_focus_plant_footer(inputs)
	if (locale === "fr") return fr_walkturough_focus_plant_footer(inputs)
	if (locale === "it") return it_walkturough_focus_plant_footer(inputs)
	if (locale === "ja") return ja_walkturough_focus_plant_footer(inputs)
	if (locale === "ko") return ko_walkturough_focus_plant_footer(inputs)
	if (locale === "pt_br") return pt_br_walkturough_focus_plant_footer(inputs)
	if (locale === "ru") return ru_walkturough_focus_plant_footer(inputs)
	if (locale === "th") return th_walkturough_focus_plant_footer(inputs)
	if (locale === "tr") return tr_walkturough_focus_plant_footer(inputs)
	if (locale === "zh_cn") return zh_cn_walkturough_focus_plant_footer(inputs)
	return zh_tw_walkturough_focus_plant_footer(inputs)
});